import { render, staticRenderFns } from "./createPush.vue?vue&type=template&id=be7b3004&scoped=true"
import script from "./createPush.vue?vue&type=script&lang=js"
export * from "./createPush.vue?vue&type=script&lang=js"
import style0 from "./createPush.vue?vue&type=style&index=0&id=be7b3004&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7b3004",
  null
  
)

export default component.exports